<div class="notice-popover">
  <kody-no-data [title]="title" [message]="text"></kody-no-data>
  <ion-button class="notice-popover__button" expand="block" (click)="done()">
    Keep browsing
    <fa-icon class="end-icon" [icon]="faChevronRight"></fa-icon>
  </ion-button>
</div>
